import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { basename, dirname, extname } from '@common/util/path';
import { StringService } from '@portal-core/general/services/string.service';
import { DestinationFileExtension } from '@portal-core/project-files/constants/file-extensions.constant';
import { Project } from '@portal-core/projects/models/project.model';

import { AvatarBase } from '@portal-core/ui/avatar/util/avatar.base';

@Component({
  selector: 'mc-destination-avatar',
  templateUrl: './destination-avatar.component.html',
  styleUrls: ['./destination-avatar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DestinationAvatarComponent extends AvatarBase {
  @Input() branchName?: string;
  @Input() project?: Project;
  @HostBinding('class.mc-destination-avatar-show-path')
  @Input() showPath?: boolean = false;
  @Input() destinationPath: string;
  @Input() destinationType: string;
  @Input() emphasizeDestinationName: boolean = true;

  get destinationBasename(): string {
    return basename(this.destinationPath, `.${DestinationFileExtension}`);
  }

  get destinationDirname(): string {
    if (typeof this.destinationPath === 'string') {
      // Trim leading 'project/destinations/' from the path since all destinations are in that folder
      return dirname(this.destinationPath.replace(/^project\/destinations\//i, ''), true);
    }
  }

  get destinationExtname(): string {
    return extname(this.destinationPath);
  }

  get isKnownDestinationType() {
    return this.destinationType === 'sftp' || this.destinationType === 'syndicate';
  }

  constructor(private stringService: StringService) {
    super();
  }

  hasAvatarImage(): boolean {
    return false;
  }

  hasPermission(): boolean {
    return true;
  }

  isDeleted(): boolean {
    return false;
  }

  isEmpty(): boolean {
    return !this.destinationPath;
  }

  encodeURIComponent(component: string): string {
    return this.stringService.encodeURIComponent(component);
  }
}
